import React from 'react';
import {withStyles} from "@material-ui/core/styles";

const styles = {
  root:{
    display:'flex',
    flexDirection:'column',
    gap: '0.75rem',
    padding:'1rem'
  },
  name:{
    fontSize: '1.75em',
    fontWeight:600,
    marginRight: 'auto',
    display:'block',
    wordBreak:'break-all',
    '& > svg':{
      color: '#005985',
      width: '1em',
      height: '1em',
      fontSize: 'inherit',
      margin: '0.2em 0.35em 0 0',
      // alignSelf: 'first baseline',
      verticalAlign: 'text-bottom',
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '1.5rem',
    position:'relative'
  },
};

function PublicAvatarView(props) {
  const { botName, width=320, height=560, textRows=4, inputWidth=48, classes } = props;

  return (
    <div className={classes.root}>
      <div className={classes.row} style={{flexWrap:'wrap-reverse'}}>
        <div className={classes.mindfile}>
          Viewing {botName}'s Avatar
        </div>
        <script src="/api/avatar.js?mindfile=31140&size=160x440"></script>
      </div>
      <div className={classes.body}>
        <iframe
          title="avatar"
          src={`/ai/aiavatar?bot=${botName}&textrows=${textRows}&height=${height}&width=${width}&inputwidth=${inputWidth}&colors=lightgreen&ts=${Date.now()}`}
          width={width}
          height={height}
        />
      </div>
    </div>
  );
}

export default withStyles(styles)(PublicAvatarView);
